export const environment = {
  production: true,
  firebase: {
    apiKey: "AIzaSyD6Da6rL-l-eyrC4q6kI4Y5YtgLh3jffE4",
    authDomain: "okto-cloud-dev.firebaseapp.com",
    projectId: "okto-cloud-dev",
    storageBucket: "okto-cloud-dev.firebasestorage.app",
    messagingSenderId: "527183180200",
    appId: "1:527183180200:web:03efe0831623d41c716d9d",
    measurementId: "G-JGJ1T3KDV1",
    databaseURL: 'https://okto-cloud-dev.firebaseio.com',
  },
  captchaKey: '',
  adobeKey: 'e153323897104b7d85fe235d19d8d880',
  filesServiceUrl: 'https://api.okto.cloud',
  commerceDomain: 'commerce-cloud-run-527183180200.europe-west1.run.app',
};
